export const AI_OPT_IN_FEATURE_FLAG = 'pkg.ai.require_optin';
export const AI_OPT_IN_SKU = 'advanced_ai';
export const AI_OPT_IN_OFFERING_TYPE = 'addon';
export const AI_OPT_IN_CURRENCY = 'USD';
export const AI_OPT_IN_PERMISSION = 'can_access_settings';
export const AI_OPT_IN_DIALOG = 'ai-opt-in-dialog';
export const AI_OPT_IN_I18N_MODULE = 'bizai-pov';

export const AI_OPT_IN_ENTRY_POINTS = {
  CHAT_INPUT: 'chat_input',
  CHAT_CHIP: 'chat_chip',
  CHAT_MIC: 'chat_mic',
  CHAT_WORKFLOW: 'chat_workflow',
  NOTES_MIC: 'notes_mic',
  NOTE_SUMMARY: 'note_summary',
  SMART_REPLY: 'smart_reply',
  SETTINGS: 'settings',
};

export const AI_OPT_IN_FEATURES = {
  BIZAI_CHAT: 'bizai_chat',
  VOICE_NOTES: 'voice_notes',
  SMART_REPLY: 'smart_reply',
  SETTINGS: 'settings',
};

export const AI_OPT_IN_SOURCES = {
  RAISE_HAND_DIALOG: 'raise_hand_dialog',
  SETTINGS_PAGE: 'settings_page',
};

export const AI_OPT_IN_DIALOG_VERSIONS = {
  TURN_ON: 'turn_on',
  ASK_ADMIN: 'ask_admin',
};

export const AI_OPT_IN_EVENTS = {
  DIALOG_SHOWN: 'Raise hand dialog shown',
  CTA_CLICKED: 'Raise hand CTA clicked',
  DISMISSED: 'Raise hand dismissed',
  OPTED_IN: 'BizAI opted in',
  OPTED_OUT: 'BizAI opted out',
  OPT_IN_FAILED: 'BizAI opt-in failed',
};

export const AI_OPT_IN_ERRORS = {
  OFFERING_NOT_FOUND: 'ai_opt_in_offering_not_found',
  SUBSCRIPTION_NOT_ACTIVE: 'ai_opt_in_subscription_not_active',
};
